import { prismicClient } from '../../infra/prismic';

export const getContentFromPrismic = async (type: string) => {
  const response = await prismicClient.getAllByType(type);

  return { response };
};
